// extracted by mini-css-extract-plugin
export var activeButton = "fc-pricing-module--activeButton--a4150";
export var activeDescription = "fc-pricing-module--activeDescription--769b8";
export var activeText = "fc-pricing-module--activeText--543c1";
export var callToAction = "fc-pricing-module--callToAction--562e7";
export var featureList = "fc-pricing-module--featureList--d7f14";
export var featureListMain = "fc-pricing-module--featureListMain--cfbf0";
export var featureMain = "fc-pricing-module--featureMain--b9cc4";
export var inactiveButton = "fc-pricing-module--inactiveButton--b34dc";
export var planDescription = "fc-pricing-module--planDescription--e6bde";
export var planEndBorder = "fc-pricing-module--planEndBorder--cca01";
export var planFeatures = "fc-pricing-module--planFeatures--a1a14";
export var planPrice = "fc-pricing-module--planPrice--47967";
export var planPricePeriod = "fc-pricing-module--planPricePeriod--e69bd";
export var planTitle = "fc-pricing-module--planTitle--6a037";
export var priceContainer = "fc-pricing-module--priceContainer--75b25";
export var priceWrapper = "fc-pricing-module--priceWrapper--2c4c5";
export var pricingPlan = "fc-pricing-module--pricingPlan--be494";
export var pricingPlanContainer = "fc-pricing-module--pricingPlanContainer--e3a5d";
export var pricingPlanContainer2 = "fc-pricing-module--pricingPlanContainer2--6d3a1";
export var pricingPlans = "fc-pricing-module--pricingPlans--8220a";
export var root = "fc-pricing-module--root--cfd8f";
export var startingText = "fc-pricing-module--startingText--f0a8c";
export var subtitle = "fc-pricing-module--subtitle--dd49e";
export var title = "fc-pricing-module--title--ac808";